/**
 * L-Manager Frontend
 * (c) SysCo systèmes de communication sa
 * @license
 *
 * Useful functions to work with phone numbers
 **/
import {
  getCountries as libGetCountries,
  getCountryCallingCode as libGetCountryCallingCode,
  parsePhoneNumberFromString as libParsePhoneNumberFromString,
  getExampleNumber as libGetExampleNumber,
  AsYouType as libAsYouType,
} from 'libphonenumber-js';
import examples from 'libphonenumber-js/mobile/examples';

const countries = libGetCountries().map((country) => {
  const callingCode = libGetCountryCallingCode(country);
  return {
    countryCode: country,
    callingCode: callingCode,
    text: `${country} (+${callingCode})`,
  };
});

/**
 * Get all countries supported by the libphonenumber-js library {@link https://catamphetamine.gitlab.io/libphonenumber-js}
 *
 * @returns {Array<String>} An array of countries
 */
export const getCountries = () => {
  return countries;
};

/**
 * Detect if the provided string is a swiss phone number
 *
 * @param {String} phoneNumber
 * @returns {Boolean}
 */
export const isSwissPhoneNumber = (phoneNumber) => {
  const parsedNumber = libParsePhoneNumberFromString(phoneNumber, 'CH');
  if (parsedNumber) {
    return true;
  }
  return false;
};

/**
 * Get the phone number format for a specified country provided in a two-letter ISO code format (CH, DE, IT, FR, etc.)
 *
 * @param {String} country
 * @returns {String}
 */
export const getPhoneNumberFormat = (country) => {
  const examplePhoneNumber = libGetExampleNumber(country, examples);
  const examplePhoneNumberFormat = examplePhoneNumber.formatInternational();
  return examplePhoneNumberFormat.replace(
    /(\+\d{1,3})\s(\d[\d\s-.]*)/g,
    (match, countryCallingCode, phoneNumber) => {
      return `${countryCallingCode} ${phoneNumber.replace(/\d/g, '0')}`;
    },
  );
};

export const onTypeFormatter = (value) => {
  return new libAsYouType('CH').input(value);
};
